import { StateCreator } from 'zustand';
import { TManualNotesSlice, TUsersStore } from './types';
import { userApi } from '@/API';
import { TCreateManualNoteRequestCamel } from '@/types';
import { convertKeys } from '@/utils/common';

export const manualNotesSlice: StateCreator<
  TUsersStore,
  [],
  [],
  TManualNotesSlice
> = (set) => ({
  addingManualNote: false,
  manualNotes: {},

  fetchManualNotes: async (userId: string, userInstitutionRoleId: string) => {
    try {
      const response = await userApi.getManualNotes(
        userId,
        userInstitutionRoleId,
      );
      const notes = convertKeys(response.data.data);
      set((state) => ({
        manualNotes: {
          ...state.manualNotes,
          [userInstitutionRoleId]: notes,
        },
      }));
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  addManualNote: async (
    userId: string,
    body: TCreateManualNoteRequestCamel,
  ) => {
    set({ addingManualNote: true });
    try {
      const response = await userApi.addManualNote(
        userId,
        convertKeys(body, 'snake'),
      );
      const note = convertKeys(response.data.data);
      set((state) => ({
        manualNotes: {
          ...state.manualNotes,
          [body.userInstitutionRoleId]: [
            ...(state.manualNotes[body.userInstitutionRoleId] ?? []),
            note,
          ],
        },
      }));
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      set({ addingManualNote: false });
    }
  },
});
